import {getDevicePlatform} from '@dazn/lp-web/src/utils/bootstrap';
import axios from 'axios';

const GOOGLE_ADS_BASE_URL = 'https://securepubads.g.doubleclick.net/gampad/adx';

const setDivOpacity = (
    divRef: React.RefObject<HTMLDivElement | null>,
    value: number
) => {
    if (!divRef.current) return;
    divRef.current.style.opacity = value.toString();
};

const loadSponsorShipLogoScript = async (
    mainDivRef: React.RefObject<HTMLDivElement | null>,
    logoDivId: string,
    slotPath: string
): Promise<void> => {
    const deviceType = getDevicePlatform();
    const url =
        GOOGLE_ADS_BASE_URL +
        '?' +
        `iu=${slotPath}` +
        `&sz=1x1` +
        `&c=${Date.now()}+${~~(Math.random() * 100)}` +
        `&title=1` +
        `&t=AdvTV_DeviceType%3D${deviceType}`;

    try {
        const response = await axios.get(url);

        if (response.status !== 200 || !response.data || !mainDivRef.current)
            return;

        const logoElement = mainDivRef.current.querySelector(`#${logoDivId}`);
        if (!logoElement) return;
        logoElement.innerHTML = response.data;

        const imgTag: HTMLImageElement | null =
            logoElement.querySelector('#google-ad-image');
        if (!imgTag) return;

        imgTag.onload = () => setDivOpacity(mainDivRef, 1);
        imgTag.onerror = () => setDivOpacity(mainDivRef, 0);
    } catch (err) {
        console.log(err);
        setDivOpacity(mainDivRef, 0);
    }
};

export {loadSponsorShipLogoScript};
